"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // styles
    styleObject: {
        display: 'block',
    },
};
